import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

/**
 * DevExpress Dashboard Parameter Values Response Interceptor
 * ParameterValuesAction ve FieldListAction endpoint'leri için:
 * Backend'den gelen {IsUpdated, Values} formatını DevExpress'in beklediği array formatına çevirir
 * Bu interceptor Angular bootstrap'tan ÖNCE kurulmalı
 */
(function setupDashboardResponseInterceptor() {
  const originalFetch = window.fetch;
  
  window.fetch = async function(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const url = typeof input === 'string' ? input : (input as Request).url || input.toString();
    
    // ParameterValuesAction VE FieldListAction endpoint'leri için müdahale et
    const isParameterValuesRequest = url.includes('ParameterValuesAction') || 
                                      url.includes('parameterValues') ||
                                      url.includes('GetParameterValues') ||
                                      url.includes('FieldListAction');
    
    if (!isParameterValuesRequest) {
      return originalFetch.call(window, input, init);
    }
    
    try {
      const response = await originalFetch.call(window, input, init);
      
      // Response başarısız ise dokunma
      if (!response.ok) {
        return response;
      }
      
      // Response'u clone et (body sadece bir kez okunabilir)
      const clone = response.clone();
      
      try {
        const data = await clone.json();
        
        // Transform gerekli mi kontrol et
        let transformed = data;
        let needsTransform = false;
        
        // {IsUpdated, Values} formatı -> Values array (DevExpress ParameterValuesAction response)
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          if (data.Values !== undefined && Array.isArray(data.Values)) {
            transformed = data.Values;
            needsTransform = true;
            console.log('📥 Parameter/Field response transformed:', url.split('/').pop(), transformed.length, 'items');
          }
        }
        
        if (needsTransform) {
          // Yeni Response oluştur
          const newHeaders = new Headers();
          response.headers.forEach((value, key) => {
            newHeaders.append(key, value);
          });
          newHeaders.set('content-type', 'application/json');
          
          return new Response(JSON.stringify(transformed), {
            status: response.status,
            statusText: response.statusText,
            headers: newHeaders
          });
        }
        
        // Transform gerekmiyorsa orijinal response'u döndür
        return response;
        
      } catch (parseError) {
        // JSON parse hatası - orijinal response'u döndür
        return response;
      }
      
    } catch (fetchError) {
      // Fetch hatası - orijinal davranış
      throw fetchError;
    }
  };
  
  console.log('✅ DevExpress ParameterValues Response Interceptor initialized');
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
